<template>
  <div class="Home padding">

    <h1>
      Live captions streamed between users.
    </h1>

    <h3 class="">
      Stream captions across the web, using popular tools for <router-link :to="{ name: 'Features'}">video calls, live streams, presentations</router-link> and more. Simple setup & no installation needed.
    </h3>

    <hr />

    <div class="columns">

      <div>
        <h2>1. Join a room</h2>
        <p>
          Enter a room.
        </p>

      </div>
      <div>
        <h2>2. Speak</h2>
        <p>
          Speak in any of 40+ languages.
        </p>
      </div>
      <div>
        <h2>3. Automatic transcription</h2>
        <p>
          Textify transcribes your speech to text.
        </p>
      </div>
      <div>
        <h2>4. Share</h2>
        <p>
          Automatically share the captions with friends.
        </p>
      </div>

    </div>

    <hr />

    <div class="columns center flex-center">
      <div>
        Try it out:
        <input type="text" v-model="roomName" placeholder="Room name" @keydown.enter="enter" />
        <button @click="enter" :disabled="!roomName">Join room</button>
        <p class="gray small">
          For best experience: use a headset in a quiet environment.
          <br />
          Works best in <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a> on desktop.
        </p>
      </div>
      <div>
        Get inspired by <router-link :to="{ name: 'Features'}">features and example use cases</router-link>!
        <p class="gray small">
          Missing something? <router-link to="/features#request">Request a feature</router-link>.
        </p>
      </div>
    </div>

    <hr />

    <div>
      <h2>Contact</h2>
      <p>
        Textify is developed by Martin Törnros @ <a href="https://interaktivarum.se" target="_blank">Interaktiva rum</a>: a freelancing design and software developer based in <a href="https://www.routesnorth.com/planning-trip-sweden/frequently-asked-questions/sweden-famous-for/" target="_blank">Sweden</a>.
      </p>

      <p>
        New functionality will be added continuously, feel free to <router-link to="/features#request">request new features</router-link>.
      </p>

      <p>
        I'm happy to hear from you at <a href="mailto:martin@interaktivarum.se">martin@interaktivarum.se</a>.
      </p>
    </div>

    <div>
      <h2>Is it free?</h2>
      <p>
        Yes!
        I develop Textify in my spare time and offer it free of charge.
      </p>
      <p>
        If you like it, feel free to <BMC class="inline"></BMC> and support the ongoing development.
      </p>
    </div>

    <div>
      <h2>Privacy</h2>
      Read about <router-link :to="{ name: 'Privacy'}">Textify privacy</router-link>.
    </div>

    <hr />

    <h3>Found a bug?</h3>
    <p>
       Please contact me at <a href="mailto:martin@interaktivarum.se">martin@interaktivarum.se</a>.
    </p>

  </div>
</template>

<script>
// @ is an alias to /src

import BMC from '@/components/BMC.vue'

export default {
  name: 'Home',
  components: {
    BMC
  },
  data: function () {
    return {
      roomName: "DemoRoom"
    }
  },
  methods: {
    enter: function () {
      this.$router.push({ name: 'Room', params: { id: this.roomName } })
    }
  },
  mounted: function () {
  }
}
</script>

<style lang="scss" scoped>

  .Home{
    padding-bottom: 50px;
  }

  .columns{
    flex-wrap: wrap;
  }

  .columns > * {
    flex: 1 0 200px;
  }

</style>
